export enum enumHeaderActionId {
  ISF_BULK,
  ISF,
  ES_BULK,
  ES,
  QUOTE,
  PRODUCT_DETAILS,
  BROKER_DISTRIBUTION,
  BROKERS,
  AFFILIATES,
  ROUTES,
  CFS,
  VOYAGE,
  CONTAINER_TYPE,
  CONTAINERS,
  CONTAINER_SEALS,
  MBL,
  HBL,
  PACKING_LIST,
  CONTACTS,
  COUPONS,
  AGENTS,
  ADDITIONAL_PAYMENT,
  PRICE_LISTS,
  LCL,
  BETA_FEATURES,
  MARINE_INSURANCE,
  PAYMENT_METHOD,
  PAYMENT_METHOD_CODE,
  GLOBAL_ALERT,
}
